import { Component, OnInit } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';
import { IUser } from '../../../models/user.model';
import { EventData } from '../../../providers/event';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'modal-question-comments',
  templateUrl: 'question-comments.modal.html'
})

export class QuestionCommentsModal implements OnInit {

  clientId: string;
  eventId: string;
  input: string;
  questionId: string;
  user: IUser;
  configColor: any;
  comments$: Observable<any[]>;

  constructor(
    private navParams: NavParams,
    public viewCtrl: ViewController,
    private eventProvider: EventData
  ) { }

  ngOnInit() {
    this.clientId = this.navParams.get('clientId');
    this.eventId = this.navParams.get('eventId');
    this.questionId = this.navParams.get('questionId');
    this.user = this.navParams.get('user');
    this.configColor = this.navParams.get('configColor');
    this.comments$ = this.eventProvider.getQuestionsComments(this.clientId, this.eventId, this.questionId);
  }

  sendComment() {
    if (this.input && this.input !== '') {
      this.eventProvider.addComment(this.clientId, this.questionId, this.user.info.id, this.eventId, this.input)
        .then(() => this.input = '');
    }
  }

}


// WEBPACK FOOTER //
// ./src/pages/question/question-comments/question-comments.modal.ts